import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { authActions } from '../../../redux/actions';
import { Container, Title, TitleRow, Button, Background, Window, WindowTitle, WindowButtons, WindowContent, Label, Input, Error } from './ProfileManager.styles';
import T from '../../i18n/i18n';
import { editPassword } from '../../../services/profile';

export default () => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [expanded, setExpanded] = useState(localStorage.getItem('config.profileExpand') === '1');
    const [openWindowChangePass, setOpenWindowChangePass] = useState(false);

    const [curPass, setCurPass] = useState("");
    const [newPass, setNewPass] = useState("");
    const [confirmPass, setConfirmPass] = useState("");
    const [error, setError] = useState("");

    const handleExpand = () => {
        setExpanded(e => {
            localStorage.setItem('config.profileExpand', !e ? '1' : '0');
            return !e;
        })
    }

    const handleLogout = () => {
        dispatch(authActions.logout());
    }

    const handleEdit = () => {
        history.push('/home/me');
    }

    const handleEditPass = () => {
        setOpenWindowChangePass(true);
    }

    const handleCloseWindow = () => {
        setOpenWindowChangePass(false);
    }

    const handleSubmit = async () => {
        if (!isValidPass()) {
            return;
        }

        let user = await editPassword(newPass, curPass, confirmPass);
        if (user.status === 'ok') {
            setOpenWindowChangePass(false);
            setCurPass("");
            setNewPass("");
            setConfirmPass("");
            setError("");
        } else {
            setError(user.payload || Translate('undefinederror'));
        }
    }

    const isValidPass = () => {
        return curPass && curPass.length >= 6 &&
            newPass && newPass.length >= 6 &&
            confirmPass && confirmPass.length >= 6 &&
            newPass === confirmPass;
    }

    return <Container>
        <TitleRow onClick={()=>{handleExpand()}} className={expanded ? 'expanded' : ''}>
            <Title><T value="profile.title" /></Title>    
        </TitleRow>
        { expanded ? <>
            <Button color={'#39f'} className={'active'} onClick={handleEdit}><T value="profile.edit" /></Button>
            <Button color={'#fc2'} className={'active'} onClick={handleEditPass}><T value="profile.changepassword" /></Button>
            <Button className={'active'} onClick={()=>{handleLogout()}} color="#f66"><T value="profile.logout" /></Button>
        </> : null }
        {openWindowChangePass ? <>
            <Background onClick={handleCloseWindow}></Background>
            <Window>
                <WindowTitle><T value="profile.changepassword" /></WindowTitle>
                <WindowContent>
                    {error ? <Error>{error}</Error> : null }
                    <Label><T value="profile.currentpass" /></Label>
                    <Input value={curPass} onChange={(e)=>setCurPass(e.target.value)}/>
                    <Label><T value="profile.newpass" /></Label>
                    <Input value={newPass} onChange={(e)=>setNewPass(e.target.value)}/>
                    <Label><T value="profile.newpassconfirm" /></Label>
                    <Input value={confirmPass} onChange={(e)=>setConfirmPass(e.target.value)}/>
                </WindowContent>
                <WindowButtons>
                    <Button className='horziontal' color="#888" onClick={handleCloseWindow} ><T value="cancel" /></Button>
                    <Button className={'horziontal ' + (isValidPass() ? "" : "disabled")} color="#39f" onClick={handleSubmit} ><T value="save" /></Button>
                </WindowButtons>
            </Window>
        </> : null}
    </Container>
};